var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"owner_main_area main_area_pc main_password_setting"},[_c('Continue',{attrs:{"step":"4"}}),_vm._v(" "),_c('Success')],1)}
var staticRenderFns = []

export { render, staticRenderFns }